import { PreserveSearchNavigate } from "../../components/Navigate/PreserveSearchNavigate.tsx";
import { Query } from "../../components/Query/Query.tsx";
import { useOnMount } from "../../hooks/useOnMount.ts";
import { useRetrainModel } from "../Board/hooks/useRetrainModel.ts";
import {
  clearShoppingCart,
  getShoppingCart,
} from "../Board/utils/shoppingCart.ts";
import {
  CHARACTER_MODEL_TYPE,
  OBJECT_MODEL_TYPE,
  STYLE_MODEL_TYPE,
} from "../constants.ts";
import { useModel } from "./hooks/useModel.ts";
import { useModelUuid } from "./hooks/useModelUuid.ts";
import { useTrainModel } from "./hooks/useTrainModel.ts";
import { ObjectAndCharacterModelCreation } from "./ObjectAndCharacterModelCreation.tsx";
import { StyleModelCreation } from "./StyleModelCreation.tsx";

export const ModelCreationView = () => {
  const modelUuid = useModelUuid();

  const shoppingCart = getShoppingCart();
  if (shoppingCart) {
    return (
      <TrainModelAndRedirect
        modelUuid={shoppingCart.modelUuid}
        trainAction={shoppingCart.trainAction}
      />
    );
  }

  return (
    <Query queryKey={`references/${modelUuid}`}>
      {() => <ModelCreation />}
    </Query>
  );
};

const ModelCreation = () => {
  const { model } = useModel();
  return (
    <div className="flex-fill w-full">
      {(() => {
        switch (model.type) {
          case STYLE_MODEL_TYPE:
            return <StyleModelCreation />;
          case CHARACTER_MODEL_TYPE:
            // XXX: We inject model to benefit from the type narrowing of the parent component instead of relying on the
            // hook `useModel` that would return a generic Model type
            return <ObjectAndCharacterModelCreation model={model} />;
          case OBJECT_MODEL_TYPE:
            // XXX: We inject model to benefit from the type narrowing of the parent component instead of relying on the
            // hook `useModel` that would return a generic Model type
            return <ObjectAndCharacterModelCreation model={model} />;
        }
      })()}
    </div>
  );
};

const TrainModelAndRedirect = ({
  modelUuid,
  trainAction,
}: {
  modelUuid: string;
  trainAction: "train" | "retrain";
}) => {
  const { mutate: trainModel } = useTrainModel({
    modelUuid,
  });
  const { mutate: retrainModel } = useRetrainModel({
    modelUuid,
  });
  useOnMount(() => {
    if (trainAction === "retrain") {
      retrainModel();
    } else {
      trainModel();
    }
    clearShoppingCart();
  });

  return <PreserveSearchNavigate to={window.location.href} />;
};
